import Alpine from 'alpinejs';
import api, { money, requireAuth } from './api.js';

function createInkoCreationCredits() {
  return {
    loading: true,
    busy: false,
    meta: null,
    catalog: null,
    subscription: null,
    creditBalance: 0,
    transactions: [],
    convertPoints: 100,

    async init() {
      if (!requireAuth()) return;
      try {
        const [meta, catalog, sub, tx] = await Promise.all([
          api.meta(),
          api.billingCatalog(),
          api.getSubscription(),
          api.listCreditTransactions(),
        ]);
        this.meta = meta;
        this.catalog = catalog;
        this.subscription = sub.subscription;
        this.creditBalance = sub.credit_balance;
        this.transactions = tx.items;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat billing.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async convertFromPoints() {
      this.busy = true;
      try {
        const result = await api.convertPoints(this.convertPoints);
        this.creditBalance = result.balance;
        if (this.meta) {
          this.meta.credits.balance = result.balance;
          this.meta.user_points = result.user_points;
        }
        window.toast?.(`${result.credits} kredit ditambahkan.`, 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Konversi gagal.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async purchase(type, itemKey) {
      this.busy = true;
      try {
        await api.purchaseBilling({ type, item_key: itemKey, payment_method: 'wallet' });
        window.toast?.('Pembelian diproses.', 'success');
        await this.init();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Pembelian gagal.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async cancelSub() {
      if (!confirm('Batalkan langganan?')) return;
      this.busy = true;
      try {
        this.subscription = await api.cancelSubscription();
        window.toast?.('Langganan dibatalkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membatalkan.', 'error');
      } finally {
        this.busy = false;
      }
    },

    money,
  };
}

Alpine.data('inkoCreationCredits', createInkoCreationCredits);
